// extracted by mini-css-extract-plugin
export default {"wrapper":"EventCountdown_wrapper_ce88b","message":"EventCountdown_message_efb30","icon":"EventCountdown_icon_e4c91"};